const domainConfig = {
    "console.ebtech-inc.com": {
        staticBaseUrl: "https://static.ebtech.com",
        apiBaseUrl: "https://console.ebtech-inc.com"
    },
    "console.ebtech-ai.com": {
        staticBaseUrl: "https://static.ebcloud.com",
        apiBaseUrl: "https://console.ebtech-ai.com"
    },
    "console.ebtech.com": {
        staticBaseUrl: "https://static.ebtech.com",
        apiBaseUrl: "https://console.ebtech.com"
    },
    "console.ebcloud.com": {
        staticBaseUrl: "https://static.ebcloud.com",
        apiBaseUrl: "https://console.ebcloud.com"
    }
};
const currentHost = window.location.hostname;
const config = domainConfig[currentHost] || domainConfig["console.ebtech-inc.com"];
export const API_BASE_URL = config.apiBaseUrl;
export const STATIC_BASE_URL = config.staticBaseUrl;
